export enum AttachmentRelevance {
	Relevant = 1,
	Irrelevant = 2,
}
